import { List, ListItem, ListItemText } from '@mui/material';

export function deleteEquipmentConfirm(deleteFn, equipment) {
  return {
    id: 'delete',
    content: (
      <>
        The following equipment will be deleted:
        <List sx={{ listStyleType: 'disc' }}>
          {equipment.map((e) => (
            <ListItem key={e.equipId} sx={{ display: 'list-item', padding: 0 }}>
              <ListItemText>{e.name}</ListItemText>
            </ListItem>
          ))}
        </List>
      </>
    ),
    onSuccess: () => deleteFn(equipment.map((e) => e.equipId)),
  };
}

export function unpublishConfirm(unpublish, equipmentIds, pointIds, unassignments, then) {
  return {
    id: 'unpublish',
    content: (
      <>
        {equipmentIds.length} equipment / {unassignments.length} point assignments will be
        unpublished
      </>
    ),
    onSuccess: () =>
      unpublish(equipmentIds, pointIds, unassignments).then((result) =>
        then ? then(result) : result
      ),
  };
}

export function deleteLocationsConfirm(
  deleteFn,
  locationNames,
  relatedLocationCount,
  relatedEquipmentCount
) {
  const plural = locationNames > 1;
  return {
    title: `Confirm Delete Location${plural ? 's' : ''}`,
    content: (
      <>
        {locationNames.length} location{plural ? 's' : ''} will be deleted, impacting{' '}
        {relatedLocationCount} other locations and {relatedEquipmentCount} equipment
      </>
    ),
    onSuccess: () => deleteFn(locationNames),
  };
}
